// import emma from '../services/Emma'
import notifs from '../fixtures/notifications'

const NotificationsResource = {
	getNotifications (id) {
		return new Promise((resolve, reject) => {
			const tmp = true
			if (tmp) {
				resolve(notifs)
			} else {
				reject(new Error('Non'))
			}
		})
	}
}

export default NotificationsResource



// WEBPACK FOOTER //
// ./src/common/resources/Notifications.js